import { render, staticRenderFns } from "./BetslipFooterCombo.vue?vue&type=template&id=d5f34ad4&scoped=true"
import script from "./BetslipFooterCombo.vue?vue&type=script&lang=js"
export * from "./BetslipFooterCombo.vue?vue&type=script&lang=js"
import style0 from "./BetslipFooterCombo.vue?vue&type=style&index=0&id=d5f34ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f34ad4",
  null
  
)

export default component.exports